import { ApiUser, IUser } from '@/types';

/**
 * Maps API user to frontend IUser format.
 *
 * @param apiUser - ApiUser object from the API
 *
 * @returns IUser formatted for the frontend
 */
export function mapApiUserToFrontend({ apiUser }: { apiUser: ApiUser }): IUser {
  return {
    certifications: [],
    createdAt: new Date(apiUser.created_at),
    department: '',
    email: apiUser.email,
    imageUrl: apiUser.imageUrl || '',
    name: apiUser.name || apiUser.full_name,
    role: apiUser.role,
    updatedAt: new Date(apiUser.updated_at),
    username: apiUser.name || apiUser.full_name,
    uuid: apiUser.id,
  };
}

/**
 * Maps array of API users to frontend IUser format.
 *
 * @param apiUsers - Array of ApiUser from the API
 *
 * @returns Array of IUser formatted for the frontend
 */
export function mapApiUsersToFrontend({ apiUsers }: { apiUsers: ApiUser[] }): IUser[] {
  return apiUsers.map((apiUser) => mapApiUserToFrontend({ apiUser }));
}
